import React from 'react';
import styled from 'styled-components';
import {
    solidButtonStyles,
    BaseSolidButtonProps,
    BaseSolidButtonContent,
} from 'libs/core-components/SolidButton/BaseSolidButton';

export interface ButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement>,
        BaseSolidButtonProps {}
const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props: ButtonProps, ref) => {
    {
        const {
            className,
            children,
            icon,
            size,
            disabled,
            processing,
            selected: selectedIgnored,
            type = 'submit',
            backgroundColor: backgroundColorIgnored,
            ...rest
        } = props;

        const isDisabled = disabled || processing;

        return (
            <button {...rest} type={type} className={className} disabled={isDisabled} ref={ref}>
                <BaseSolidButtonContent
                    icon={icon}
                    label={children}
                    size={size}
                    processing={processing}
                />
            </button>
        );
    }
});

export const SolidButton = styled(Button)<ButtonProps>(solidButtonStyles);
